import { loopbackGet, loopbackPost } from '..';

import { Review, Submission, Enrollment } from '../../redux/types';

export type SubmissionWithEnrollment = Submission & { enrollment: Enrollment };

// eslint-disable-next-line import/prefer-default-export
export const getSubmissions = (surveyId: number): Promise<SubmissionWithEnrollment[]> => {
  const filter = {
    where: {
      surveyId,
    },
    include: 'enrollment',
  };
  return loopbackGet(`/submissions?filter=${JSON.stringify(filter)}`);
};

export const getReviewFromSubmission = (submissionId: number): Promise<Review> => loopbackGet(`Submissions/${submissionId}/getReviewFromSubmission`);

export const allowPostResubmit = (enrollmentId: number, extendedDate: string): Promise<void> => {
  const uri = `enrollments/${enrollmentId}/reopen`;
  return loopbackPost(uri, { extendedDate });
};

export const checkExpiredAndReset = (submissionId: number): Promise<boolean> => {
  // the model might have to change to enrollment
  const uri = `submissions/${submissionId}/checkExpiredAndReset`;
  return loopbackPost(uri);
};
